import { createUseStyles } from 'react-jss';

const styles = createUseStyles(theme => {
  const { spacing, border, radius, palette } = theme;
  return {
    appCardBorder: {
      border: border.muted,
      borderRadius: radius.medium,
      background: palette.background.light,
      '&:hover': {
        border: border.hover,
      },
    },
    appCard: {
      padding: `${spacing[4]}px`,
      '@media screen and (min-width: 576px)': {
        minHeight: '250px',
      },
      '@media screen and (max-width: 575px)': {
        minHeight: '280px',
      },
    },
    appCardLogo: {
      height: '50px',
    },
  };
});

export default styles;
